import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {LoginService} from '../login/login.service';
import {RegAlarmaService} from '../regAlarma/regAlarma.service';
import {MenuService} from '../menu/menu.service';
import {FilterPipe} from '../navLeft/filtro';
import {ROUTER_DIRECTIVES} from '@angular/router';
import {DocumentoService} from "../documento/documento.service";

declare var $: any;

@Component({
    selector: 'NavSup',
    template: require('../../app/navSup/navSup.component.html'),
    styles: [require('../../app/navSup/navSup.component.css')],
    directives: [ROUTER_DIRECTIVES],
    pipes: [FilterPipe]
})


export class NavSupComponent implements OnInit, OnDestroy {
    showNavBar: boolean;
    @Input() cantNotificaciones: any;
    usuario: any;
    @Input() urlLogo: any;
    menus: any;
    @Input() alertaCalibracion: any;
    cantDocumentos: number;

    constructor(private loginService: LoginService,
                private regAlarmaService: RegAlarmaService,
                private menuService: MenuService,
                private documentoService: DocumentoService) {
        this.showNavBar = this.loginService.isLoggedIn() && !this.loginService.getDecodeToken().cambiarPassword;

        this.loginService.logIn.subscribe((mode) => {
            this.usuario = this.loginService.getDecodeToken();
            this.showNavBar = mode && !this.loginService.getDecodeToken().cambiarPassword;
            if (mode == true) {
                this.menuService.getMenus().subscribe((menus) => {
                    this.menus = menus;
                });
            }
            if (this.usuario.rol == 'Administrador' || this.usuario.rol == 'Tecnico' || this.usuario.rol == 'Empresa')
                this.documentoService.getDocumentos().subscribe();
        });

        //Cargo usuario
        if (this.loginService.isLoggedIn())
            this.usuario = this.loginService.getDecodeToken();

        this.cantDocumentos = -1;
        if (this.loginService.isLoggedIn() && (this.usuario.rol == 'Administrador' || this.usuario.rol == 'Tecnico' || this.usuario.rol == 'Empresa'))
            this.documentoService.getDocumentos().subscribe();
        this.documentoService.documentos$.subscribe((documentos) => {
            let cantDocumentos = documentos.length === 0 ? -1 : 0;
            documentos.forEach((documento) => {
                if (documento.usuariosNotificados.indexOf(this.usuario.id) === -1 && documento.estado === true)
                    cantDocumentos++;
            })
            this.cantDocumentos = cantDocumentos;
        });


    }


    ngOnInit() {
        if (this.showNavBar)
            this.menuService.getMenus().subscribe((menus) => {
                this.menus = menus;
            });

        $(document).bind("mouseup touchend", function (e) {
            var container = $("#right-sidebar-wrapper");
            if (!container.is(e.target) // if the target of the click isn't the container...
                && container.has(e.target).length === 0
                && e.target.id != "logoEmpresa" && e.target.id != "iconoAlarma" && e.target.id != "btnNavRight" && e.target.className != "icon-bar" && e.target.className != "previewFotoPerfil") // ... nor a descendant of the container
            {
                $(".wrapper").removeClass("right-toggled");
            }
            var container = $("#navLeftRes");
            if (!container.is(e.target) // if the target of the click isn't the container...
                && container.has(e.target).length === 0
                && e.target.id != "btnNavLeft" && e.target.className != "icon-bar") // ... nor a descendant of the container
            {
                $('#navbarCollapse').removeClass('in');
                $('#navbarCollapse').addClass('collapse');
            }
        })
    }

    ngOnDestroy() {
        this.cantNotificaciones = 0;
    }


    logout() {
        this.loginService.logout();
    }

    toogleBar() {
        $('.wrapper').toggleClass('right-toggled')
    }

    toogleLeftBar() {
        $('#navbarCollapse').toggleClass('collapse in');
    }

    toggleRightAlarma() {
        $(".wrapper").toggleClass("right-toggled");

        $("#notificaciones").addClass('active in');
        $("#configuracion").removeClass('active in');
        $("#notificacionesRango").removeClass('active in');
        $("#error").removeClass('active in');
        $("#notificacionesLink").addClass('active');
        $("#configuracionLink").removeClass('active');
        $("#notificacionesRangoLink").removeClass('active');
        $("#errorLink").removeClass('active');
    }

    toggleRightConfiguracion() {
        $(".wrapper").toggleClass("right-toggled");

        $("#notificaciones").removeClass('active in');
        $("#notificacionesRango").removeClass('active in');
        $("#configuracion").addClass('active in');
        $("#error").removeClass('active in');
        $("#notificacionesLink").removeClass('active');
        $("#notificacionesRangoLink").removeClass('active');
        $("#configuracionLink").addClass('active');
        $("#errorLink").removeClass('active');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/navSup/navSup.component.ts